import propTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

export const PricingPlan = (props) => {
  const { onClick, cta, currency, description, features, image, name, popular, price, sx, ...other } = props;

  return (
    <Card
      sx={{
        backgroundColor: (theme) => theme.palette.mode === 'dark'
          ? 'neutral.900'
          : 'neutral.100',
        display: 'flex',
        flexDirection: 'column',
        ...sx
      }}
      {...other}>
      <Box sx={{ p: 1.5 }}>
        <Box
          sx={{
            alignItems: 'center',
            backgroundColor: 'neutral.50',
            backgroundImage: `url(${image})`,
            borderRadius: 1,
            display: 'flex',
            justifyContent: 'center',
            overflow: 'auto',
            height: 400,
            maxWidth: 470,
            mx: 'auto',
            border: "0px solid red",
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        />

        {/* <Box
          sx={{
            backgroundImage: `url(${image})`,
            borderRadius: 1,
            width: '100%',
            height: {
              xs: 180,   // mobile
              sm: 240,   // tablet
              md: 300    // desktop
              md: 400    // desktop
            },
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        /> */}


        <Box sx={{ display: 'flex', mt: 1 }}>
          <Typography variant="h6">
            {`${currency} ${price}`}
          </Typography>
        </Box>
        <Typography
          sx={{ mt: 0 }}
          variant="subtitle1"
        >
          {name}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          p: 1
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: -2,
            mb: 1
          }}
        >
          <Button
            sx={{ marginInline: 0.5 }}
            onClick={onClick}
            fullWidth
            variant={popular ? 'contained' : 'outlined'}
          >
            {cta}
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

PricingPlan.propTypes = {
  cta: propTypes.string.isRequired,
  currency: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  features: propTypes.array.isRequired,
  icon: propTypes.any.isRequired,
  name: propTypes.string.isRequired,
  popular: propTypes.bool,
  price: propTypes.string.isRequired,
  sx: propTypes.object
};
